export default __webpack_public_path__ + "static/media/document-text-primary.aaaf4109.svg";